export default __webpack_public_path__ + "static/media/neg.004f0109.png";